/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Type_MessageInputs */

const en_type_message = /** @type {(inputs: Type_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a message...`)
};

const es_type_message = /** @type {(inputs: Type_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe un mensaje...`)
};

const fr_type_message = /** @type {(inputs: Type_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez un message...`)
};

const de_type_message = /** @type {(inputs: Type_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreibe eine Nachricht...`)
};

const id_type_message = /** @type {(inputs: Type_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketik pesan...`)
};

/** @type {(inputs: Type_MessageInputs) => LocalizedString} */
const ja_type_message = en_type_message;

/** @type {(inputs: Type_MessageInputs) => LocalizedString} */
const zh_type_message = en_type_message;

/** @type {(inputs: Type_MessageInputs) => LocalizedString} */
const ar_type_message = en_type_message;

/** @type {(inputs: Type_MessageInputs) => LocalizedString} */
const it_type_message = en_type_message;

/** @type {(inputs: Type_MessageInputs) => LocalizedString} */
const ru_type_message = en_type_message;

/** @type {(inputs: Type_MessageInputs) => LocalizedString} */
const pt_type_message = en_type_message;

/** @type {(inputs: Type_MessageInputs) => LocalizedString} */
const ko_type_message = en_type_message;

/**
* | output |
* | --- |
* | "Type a message..." |
*
* @param {Type_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const type_message = /** @type {((inputs?: Type_MessageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Type_MessageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_type_message(inputs)
	if (locale === "es") return es_type_message(inputs)
	if (locale === "fr") return fr_type_message(inputs)
	if (locale === "de") return de_type_message(inputs)
	if (locale === "ja") return ja_type_message(inputs)
	if (locale === "zh") return zh_type_message(inputs)
	if (locale === "ar") return ar_type_message(inputs)
	if (locale === "id") return id_type_message(inputs)
	if (locale === "it") return it_type_message(inputs)
	if (locale === "ru") return ru_type_message(inputs)
	if (locale === "pt") return pt_type_message(inputs)
	return ko_type_message(inputs)
});